'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('derailers', {
      url: '/derailers',
      template: '<derailers></derailers>'
    });
}
